import { render, staticRenderFns } from "./CardDetail.vue?vue&type=template&id=a2c429f0&scoped=true"
import script from "./CardDetail.vue?vue&type=script&lang=js"
export * from "./CardDetail.vue?vue&type=script&lang=js"
import style0 from "./CardDetail.vue?vue&type=style&index=0&id=a2c429f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c429f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2c429f0')) {
      api.createRecord('a2c429f0', component.options)
    } else {
      api.reload('a2c429f0', component.options)
    }
    module.hot.accept("./CardDetail.vue?vue&type=template&id=a2c429f0&scoped=true", function () {
      api.rerender('a2c429f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/details/CardDetail.vue"
export default component.exports